import axios from "axios";
import apiURLandKEYS from "../../Services/apiURLandKEYS";

const nextApi = axios.create({
  baseURL: apiURLandKEYS.nextUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

/* 
nextApi.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
nextApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      TokenService.removeUser();
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
); */

export default nextApi;
